import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { useTranslation } from 'react-i18next';

SliderItem.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
};

function SliderItem(props) {
    const { item, index = 0 } = props;

    const { t } = useTranslation();

    // Sahifada faqat bitta h1 bo'lishi kerak: birinchi slayd — h1,
    // qolgan slaydlar vizual jihatdan bir xil, lekin sarlavha tegi emas.
    const Heading = index === 0 ? 'h1' : 'div';

    return (
        <div className={`box-slider ${item.classAction ?? ''}`}>
            <div className="box-slider__main">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-md-12">
                            <div className="content-box">
                                <span className="brand-asterisk hero-asterisk">&#10033;</span>
                                <Heading className="title h1">
                                    {t(item.title)}{' '}
                                    <span className="accent">{t(item.span ?? '')}</span>
                                </Heading>
                                <p className="sub-title">{t(item.desc)}</p>
                                <div className="wrap-btn">
                                    <a href="tel:+998909541262" className="tf-button btn-effect">
                                        <span className="effect">{t('free-advice')}</span>
                                    </a>
                                    <a href="#portfolio" className="tf-button btn-effect ghost">
                                        <span className="effect">{t('portfolio')} &#8599;</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-md-12">
                            <div className="image">
                                {item.img && <img src={item.img} alt="Innobek" width="1400" height="875" />}
                            </div>
                        </div>
                    </div>

                    <div className="hero-meta brand-meta-bar">
                        <span>INNOBEK &mdash; IT kompaniya</span>
                        <span className="accent">+998 90 954 12 62</span>
                        <span className="hero-meta__hide">innobek.uz</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SliderItem;
